import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-xl">Loading...</div>
      </div>
    );
  }

  const adminEmail = 'admin@blendonics.com';
  if (!user || (user.email !== adminEmail && !user.is_admin)) {
    return <Navigate to="/" />;
  }

  return children;
};

export default AdminRoute;